import { render, staticRenderFns } from "./RentalHistoryNotice.vue?vue&type=template&id=5c63d69d&scoped=true&"
import script from "./RentalHistoryNotice.vue?vue&type=script&lang=js&"
export * from "./RentalHistoryNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c63d69d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c63d69d')) {
      api.createRecord('5c63d69d', component.options)
    } else {
      api.reload('5c63d69d', component.options)
    }
    module.hot.accept("./RentalHistoryNotice.vue?vue&type=template&id=5c63d69d&scoped=true&", function () {
      api.rerender('5c63d69d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/RentalHistoryNotice.vue"
export default component.exports